/* eslint-disable @typescript-eslint/explicit-member-accessibility */
/* eslint-disable no-param-reassign */
import PPTPasteParser from './PPTPasteParser';
import CPUtils from '../cp-utils';

import { deleteTagByTagName, randomString, validUrl } from './ParserUtils';
import _get from 'lodash/get';
import { CUSTOM } from '@src/slide/infrastructure/module/dependent/config/tob/constant';

export const placeHolderUrl = CUSTOM.COPYPASTE.PLACEHOLDER['1X'];
export const retinaPlaceHolderUrl = CUSTOM.COPYPASTE.PLACEHOLDER['2X'];
type lineElements= any[];

export const DOMParseENDTAG = 'DOMParseENDTAG';
export const DOMToSimpleNodeENDTAG = 'DOMToSimpleNodeENDTAG';
// 负责html预处理，将html处理成 文本、表格、图片，标签的格式
class ParsePasteHTML {
    public static instance;
    public static getSingleton = () => {
        if (!ParsePasteHTML.instance) {
            ParsePasteHTML.instance = new ParsePasteHTML();
        }
        return ParsePasteHTML.instance;
    };

    // 解析图文 html
    parseHTML = (htmlString: any, callBack: any) => {
        if (!htmlString) {
            return null;
        }
        htmlString = this.securityCheck(htmlString);// 安全校验
        htmlString = this.clipHTML(htmlString);// 精简html

        if (!htmlString) {
            return null;
        }
        const parser = new DOMParser();
        const documentCopy = parser.parseFromString(htmlString, 'text/html');
        if (callBack) {
            callBack(DOMParseENDTAG);
        }
        if (documentCopy?.body) {
            const styles = documentCopy.getElementsByTagName('style');
            let style: any;
            if (styles.length > 0) {
                style = styles[0].cloneNode(true);
            }
            for (let i = 0; i < styles.length; i++) { // 某些浏览器拷贝的东西，style会在body里，所以在解析body的时候需要去掉
                const styleItem = styles[i];
                if (styleItem.parentNode) {
                    styleItem.parentNode.removeChild(styleItem);
                }
            }
            const res = this.parseNodes(documentCopy.body);
            if (callBack) {
                callBack(DOMToSimpleNodeENDTAG);
            }
            if (res) {
                const data = PPTPasteParser.getSingleton().parse(res, style, this);
                return {
                    // 根据逻辑判断，data.richTextData 长度是 0 或 1，所以如果有值，可以直接使用 dataList[0] 获取
                    dataList: data.richTextData,
                    tableList: data.tableData,
                    images: res.images,
                };
            }
            return null;
        }
    };

    // Security check; delete <script> & <iframe>
    securityCheck = (htmlString: any) => {
        htmlString = deleteTagByTagName(htmlString, 'script');
        htmlString = deleteTagByTagName(htmlString, 'iframe');
        return htmlString;
    };

    clipHTML = (htmlString: any) => {
        if (!htmlString) {
            return null;
        }
        function clipStr(htmlStr: any, start: any, end: any, inner: any) {
            let indexStart = htmlStr.indexOf(start);
            let indexEnd = htmlStr.lastIndexOf(end);
            if (indexStart !== -1 && indexEnd !== -1) {
                if (inner) {
                    indexStart += start.length;
                } else {
                    indexEnd += end.length;
                }
                htmlStr = htmlStr.substring(indexStart, indexEnd);
            }
            return htmlStr;
        }
        // 过滤重复的html标签
        let strStart = '<html>\r\n<body>\r\n<!--StartFragment-->';
        let strEnd = '<!--EndFragment-->\r\n</body>\r\n</html>';
        htmlString = clipStr(htmlString, strStart, strEnd, true);
        // 过滤html后的脏数据
        strStart = '<html';
        strEnd = '</html>';
        htmlString = clipStr(htmlString, strStart, strEnd, false);
        return htmlString;
    };

    makeMap(str: any) {
        const obj: any = {};
        const items = str.split(',');
        for (let i = 0; i < items.length; i++) obj[items[i]] = true;
        return obj;
    }

    parseNodes(rootNode: any) {
        const rows: lineElements[] = [];
        let images: any = [];
        // Block Elements - HTML 5
        const block = this.makeMap('address,article,applet,aside,audio,blockquote,button,canvas,center,div,dd,del,dir,dl,dt,fieldset,figcaption,figure,footer,form,frameset,h1,h2,h3,h4,h5,h6,header,hgroup,hr,iframe,img,ins,isindex,li,map,menu,noframes,noscript,object,ol,output,p,pre,section,script,table,tbody,td,tfoot,th,thead,tr,ul,video,slide-data');

        const needErgodicBlock = this.makeMap('div,p,ul,td');

        const ignoreBlock = this.makeMap('table,img');
        // // Inline Elements - HTML 5
        // const inline = makeMap("abbr,acronym,applet,b,basefont,bdo,big,br,button,cite,del,dfn,em,font,i,iframe,img,
        // input,ins,kbd,label,map,object,q,s,samp,script,select,small,span,strike,strong,sub,sup,textarea,tt,u,var");
        /*
        块级元素处理成一行
        连续的非块级元素（文本、行内元素）单独成一行
        br强制换行
        table/img 特殊处理
        */
        // TODO 这里初步看是深度优先遍历dom树，但对如何换行是有问题，代码只处理了 TEXT -> span标签 或者 br标签，
        // 前者是错误的，正确做法应该是对块级元素完成遍历后进行换行，代码是丢失了块级元素换行信息导致无法正常处理，
        // TODO ol不支持 就变成一行
        // done 这里之前把所有行内元素都变成一个行内元素，因为之前不支持富文本
        // done 现在改成支持多个行内元素来支持富文本
        // dfs 遍历节点
        // a,abbr,acronym,b,bdo,big,br,cite,code,dfn,em,font,i,img,input,kbd,label,q,s,samp,select,small,
        // span,strike,strong,sub,sup,textarea,tt,u,var,text
        const inline = this.makeMap('a,abbr,acronym,b,bdo,big,br,cite,code,dfn,em,font,i,img,input,kbd,label,q,s,samp,select,small,span,strike,strong,sub,sup,textarea,tt,u,var,text'); // 支持的文本类型，不进行换行
        if (rootNode) {
            const stack: any = [];
            stack.push(rootNode);
            this.processNodes(rows, inline, block, needErgodicBlock, stack, ignoreBlock);
        }
        const newNows: any[][] = rows;

        // 处理图片
        images = this.processImages(rootNode, images);
        // 处理表格
        const tables: any = this.processTables(rootNode);

        return {
            nodes: newNows,
            images,
            table: tables,
        };
    }

    getImageData = (imgTag: any, src: any, row: any, col: any, hasVShape: any) => {
        const isBase64 = /^data:image\/(png|gif|jpeg|x-icon|jpg|tiff);base64,.+/i.test(src);
        const { $ } = window as any;
        // 本地图片
        if (this.isLocalImage(src, hasVShape, isBase64)) {
            // console.log(src);
            if (window.devicePixelRatio && window.devicePixelRatio >= 2) {
                src = retinaPlaceHolderUrl;
            } else {
                src = placeHolderUrl;
            }
            imgTag.src = src;
            const imgData = {
                isLocal: true,
                isFromHTML: true,
                id: `attachment-${+new Date()}-${randomString()}`,
                url: src,
                order: void 0,
                size: {
                    width: 440,
                    height: 330,
                },
                anchor: {
                    row,
                    col,
                },
                offset: {
                    x: 0,
                    y: 0,
                },
                clipInfo: {
                    clipTop: 0,
                    clipLeft: 0,
                    clipRight: 0,
                    clipBottom: 0,
                },
            };
            return imgData;
        } if (validUrl(src) || isBase64) {
            const domainFromUrl = function (url: any) {
                let result;
                let match;
                if (
                    (match = url.match(/^(?:https?:\/\/)?(?:[^@\n]+@)?(?:www\.)?([^:/\n?=]+)/im))
                ) {
                    result = match[1];
                    if ((match = result.match(/^[^.]+\.(.+\..+)$/))) {
                        result = match[1];
                    }
                }
                return result;
            };

            const width = this.getWidth(imgTag);
            const height = this.getHeight(imgTag);

            // 图片裁剪
            let clipTop = 0;
            let clipRight = 0;
            let clipBottom = 0;
            let clipLeft = 0;
            const { clip } = imgTag.dataset;
            if (clip) {
                const matches = clip.match(/[\d.]+/g);
                if (matches.length >= 4) {
                    [clipTop, clipRight, clipBottom, clipLeft] = matches.map(Number);
                }
            }

            const offsetX = this.getOffsetX(imgTag);
            const offsetY = this.getOffsetY(imgTag);
            let imgData = {
                isFromHTML: true,
                placeHolder: true,
                url: src,
                id: `attachment-${+new Date()}-${randomString()}`,
                type: 'pic',
                order: void 0,
                anchor: {
                    row,
                    col,
                },
                offset: {
                    x: offsetX,
                    y: offsetY,
                },
                size: {
                    width,
                    height,
                },
                clipInfo: {
                    clipTop,
                    clipLeft,
                    clipRight,
                    clipBottom,
                },
            };

            // 取出存取的插件数据
            const addonData = imgTag.attributes.getNamedItem('addon');
            if (addonData) {
                // 解析插件数据
                const { value } = addonData;
                const addon = CPUtils.parseAddonData(value);
                imgData = Object.assign(imgData, { addon });
            }

            return imgData;
        }
        return null;
    };

    public getParentNode(node: any, tagName: string, block: any) {
        let resultNode = node;
        let resultTagName = tagName;
        while (resultNode) {
            resultTagName = resultNode.tagName.toLowerCase();
            if (resultNode.nodeType === Node.ELEMENT_NODE && (block[resultTagName] || resultTagName === 'body')) {
                break;
            }
            resultNode = resultNode.parentNode || resultNode.parentNodeText;
            resultTagName = resultNode.tagName;
        }
        return { resultNode, resultTagName };
    }

    private getWidth = (imgTag: any) => (imgTag.style.width ? parseInt(imgTag.style.width.replace('px', '')) : -1);
    private getHeight = (imgTag: any) => (imgTag.style.height ? parseInt(imgTag.style.height.replace('px', '')) : -1);
    private getOffsetX = (imgTag: any) => (imgTag.style.marginLeft ? parseInt(imgTag.style.marginLeft.replace('px', '')) : -1);
    private getOffsetY = (imgTag: any) => (imgTag.style.marginTop ? parseInt(imgTag.style.marginTop.replace('px', '')) : -1);
    private isLocalImage = (src: any, hasVShape: any, isBase64: any) => src.match(/^file:\/\/[/].+(gif|jpg|jpeg|tiff|png)$/i) || (hasVShape && !isBase64);

    private processNodes(
        rows: lineElements[], inline: any, block: any,
        needErgodicBlock: any, stack: any, ignoreBlock: any,
    ) {
        while (stack.length !== 0) {
            const node: any = stack.pop();
            const result = this.processNode(node, rows, inline, block, needErgodicBlock, stack, ignoreBlock);
            if (result) {
                continue;
            }
            this.processNodeStack(node, stack);
        }
    }

    private isNeedProcess = (tagName: any, node: any, inline: any, needErgodicBlock: any) => needErgodicBlock[tagName]
    || (inline[tagName] && node.childElementCount > 0);

    private processNode(
        node: any, rows: lineElements[],
        inline: any, block: any, needErgodicBlock: any, stack: any, ignoreBlock: any,
    ) {
        if (node.nodeType === Node.TEXT_NODE) {
            // 处理文本节点
            this.processTextNode(node, rows, inline);
            return true;
        }

        if (node.nodeType === Node.ELEMENT_NODE) {
            // 处理块元素
            const tagName = node.tagName.toLowerCase();
            if (block[tagName] || (inline[tagName] && node.childElementCount > 0)) {
                // 处理 div
                if (this.isNeedProcess(tagName, node, inline, needErgodicBlock)) { // 标签 需要遍历子元素
                    const childrenDIV = node.getElementsByTagName('div');
                    // 只处理最内层 div
                    this.processDiv(childrenDIV, node, stack, rows);
                    return true;
                }
                // 表格 、 image 跳过，直接后面处理
                if (ignoreBlock[tagName]) {
                    return true;
                }
                rows.push([node]);
                return true;
            }
            if (tagName === 'br') { // 处理换行
                this.processLineFeed(rows, inline);
                return true;
            }
            // 合并文本元素到上一行
            const result = this.processMerge(node, inline, rows, block);
            if (result) {
                return true;
            }
        }
        return false;
    }

    private processNodeStack(node: any, stack: any) {
        if (node.tagName && node.tagName.toLowerCase() !== 'span') {
            const { childNodes } = node;
            for (let i = childNodes.length - 1; i >= 0; i--) {
                stack.push(childNodes[i]);
            }
        } else if (!node.handled) {
            node.handled = true;
            stack.push(node);
        }
    }

    private processMerge(node: any, inline: any, rows: lineElements[], block: any) {
        if (node.children.length === 0 || inline[node.tagName.toLowerCase()] >= 0) {
            const text = node.textContent || '';
            if (text.length > 0) {
                this.processMergeImpl(rows, inline, block, node);
                return true;
            }
            if (node.tagName.toLowerCase() !== 'a') {
                return true;
            }
        }
        return false;
    }
    private processMergeImpl(rows: lineElements[], inline: any, block: any, node: any) {
        const lastNodeStack = rows[rows.length - 1]; // 上一个遍历的元素栈
        const lastNode = lastNodeStack && lastNodeStack[lastNodeStack.length - 1]; // 上一个遍历的元素
        // eslint-disable-next-line no-shadow
        const tagName = lastNode?.tagName?.toLowerCase();
        if (_get(lastNode, 'newRow') // 存在强制换行
            || (lastNode && inline[lastNode.tagName.toLowerCase()] < 0) // 不是文本标签
            || block[tagName]) { // 是快元素
            rows.push([node]);
        } else if (lastNode && inline[lastNode.tagName.toLowerCase()] >= 0) { // 可能会需要合并
            this.tryMerge(lastNode, block, node, lastNodeStack, rows);
        } else if (lastNode && !lastNode.newRow) {
            lastNodeStack.push(node);
        } else {
            rows.push([node]);
        }
    }

    private tryMerge(lastNode: any, block: any, node: any, lastNodeStack: lineElements, rows: lineElements[]) {
        let lastNodeParent = lastNode.parentNode || lastNode.parentNodeText; // 上一次遍历的node父节点
        let tagName = '';
        let result = this.getParentNode(lastNodeParent, tagName, block);
        tagName = result.resultTagName;
        lastNodeParent = result.resultNode;

        let currentNodeParent = node.parentNode || node.parentNodeText; // 当前遍历元素node父节点
        tagName = '';
        result = this.getParentNode(currentNodeParent, tagName, block);
        tagName = result.resultTagName;
        currentNodeParent = result.resultNode;

        // 相同块级父元素合并文本
        if (lastNode && !lastNode.newRow
            && (lastNodeParent || currentNodeParent) && lastNodeParent === currentNodeParent) {
            lastNodeStack.push(node);
        } else {
            rows.push([node]);
        }
    }

    private processTables(rootNode: any) {
        const tableTags = rootNode.getElementsByTagName('table');
        const tables: any = [];
        // 处理表格
        if (tableTags && tableTags.length > 0) {
            for (let i = 0; i < tableTags.length; i++) {
                const tableNode = tableTags[i];
                tables.push(tableNode);
            }
        }
        return tables;
    }

    private processImages(rootNode: any, images: any) {
        const imageTags = rootNode.getElementsByTagName('img');
        images = [];
        if (imageTags && imageTags.length > 0) {
            for (let i = 0; i < imageTags.length; i++) {
                const imgTag = imageTags[i];
                const dataSrc = imgTag.getAttribute('data-src');
                const src = imgTag.src.includes('localhost') ? dataSrc : imgTag.src;
                const col = 0;
                const hasVShape = typeof imgTag.attributes['v:shapes'] !== 'undefined';
                const imgData = this.getImageData(imgTag, src, 0, col, hasVShape);
                if (imgData) {
                    images.push(imgData);
                }
            }
        }
        return images;
    }

    private processLineFeed(rows: lineElements[], inline: any) {
        const lastNodeStack = rows[rows.length - 1];
        const lastNode = lastNodeStack && lastNodeStack[lastNodeStack.length - 1];
        if (lastNode
            && (lastNode?.tagName
                && inline[lastNode.tagName.toLowerCase()])
            && lastNode
            && !lastNode.newRow) {
            // 强制换行
            lastNode.newRow = true;
        }
    }

    private processDiv(childrenDIV: any, node: any, stack: any, rows: lineElements[]) {
        if (childrenDIV.length > 0) {
            const { childNodes } = node;
            for (let i = childNodes.length - 1; i >= 0; i--) {
                stack.push(childNodes[i]);
            }
        } else {
            this.processChildNodes(node, stack, rows);
        }
    }

    // eslint-disable-next-line complexity
    private processChildNodes(node: any, stack: any, rows: lineElements[]) {
        const { childNodes } = node;
        if (childNodes.length === 1) {
            const [child] = childNodes;
            // 如果父级标签有href属性，则将其传给子标签，防止链接丢失
            if (node.href) child.href = node.href;
            if (child.nodeType === Node.TEXT_NODE) {
                let text = child.nodeValue;
                text = text.replace(/^\s+|\s+$/g, ''); // 去掉头尾空格或换行
                if (text.length > 0) {
                    rows.push([node]);
                }
            } else if (child.nodeType === Node.ELEMENT_NODE) {
                stack.push(child);
            }
        } else if (childNodes.length > 1) {
            for (let i = childNodes.length - 1; i >= 0; i--) {
                const childNode = childNodes[i];
                if (childNode.nodeType === Node.TEXT_NODE) {
                    // 如果子元素是文本节点，创建一个元素节点替换，否则在下一轮循环时会直接把当前文字节点拼接到上一行，可能会导致段落分割错误
                    const text = childNode.nodeValue.replace(/^\s+|\s+$/g, '');
                    if (text) {
                        const textNode = document.createElement('span');
                        textNode.textContent = text;
                        if (node.href) {
                            textNode.setAttribute('href', node.href);
                        }
                        // 替换掉原有文本节点
                        childNode.parentNode.insertBefore(textNode, childNode);
                        childNode.parentNode.removeChild(childNode);
                        stack.push(textNode);
                    }
                    continue;
                }
                // 如果父级标签有href属性，则将其传给子标签，防止链接丢失
                if (node.href) childNode.href = node.href;
                stack.push(childNode);
            }
        }
    }

    private processTextNode(node: any, rows: lineElements[], inline: any) {
        let text = node.nodeValue;
        text = text.replace(/^\s+|\s+$/g, ''); // 去掉头尾空格或换行
        if (text.length > 0) {
            // console.log('content' + text);
            const lastNodeStack = rows[rows.length - 1];
            const lastNode = lastNodeStack && lastNodeStack[lastNodeStack.length - 1];
            const textNode = document.createElement('span');
            textNode.textContent = text;
            Reflect.set(textNode, 'parentNodeText', node.parentNode);
            Reflect.set(textNode, 'parentElementText', node.parentElement);
            if (lastNode?.tagName
                && inline[lastNode.tagName.toLowerCase()]
                && lastNode
                && !lastNode.newRow) {
                lastNodeStack.push(textNode);
            } else {
                rows.push([textNode]);
            }
        }
    }
}

export default ParsePasteHTML;
